import { toast } from '../../common_components/Toast/ToastUtils';
import XLSX from 'xlsx-js-style';
const titleStyle = {
    font: { bold: true, sz: 20, color: { rgb: '181D27' } },
    alignment: { horizontal: 'center', vertical: 'center' },
};
const columnHeaderStyle = {
    font: { bold: true, sz: 12, color: { rgb: '000000' } },
    fill: { fgColor: { rgb: 'EAECF0' } },
    alignment: { horizontal: 'center', vertical: 'center' },
    border: {
        top: { style: 'thin', color: { rgb: 'D0D5DD' } },
        bottom: { style: 'thin', color: { rgb: 'D0D5DD' } },
    }
};
const cellStyle = {
    alignment: { vertical: 'center', wrapText: true },
    font: { sz: 10, color: { rgb: '344054' } },
};
export function exportContentOpportunity(rows) {
    if (!rows || !Array.isArray(rows) || rows.length === 0) {
        toast.info('No data available to export');
        return;
    }
    const formatDate = (value) => {
        if (!value)
            return '';
        try {
            const d = new Date(value);
            if (isNaN(d.getTime()))
                return '';
            return d.toLocaleDateString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
            });
        }
        catch {
            return '';
        }
    };
    try {
        const header = [
            'Category',
            'Type',
            'Content Type',
            'Name',
            'Website',
            'Monthly Organic Traffic',
            'Authority Score',
            'Facebook',
            'Instagram',
            'Youtube',
            'Tiktok',
            'Other',
            'Contact Name',
            'Contact Email',
            'Requirement',
            'Tags',
            'Date Added',
            'Notes',
        ];
        const toExcelValue = (val) => {
            if (val === null || val === undefined || val === '')
                return '0';
            const str = String(val).trim();
            // Force Excel to treat large numeric values as text
            if (/^\d+$/.test(str) && str.length > 11) {
                return `'${str}`;
            }
            return str;
        };
        const data = rows.map((row) => {
            const stats = row.stats || {};
            return [
                row.category_label || row.category || '--',
                row.type_label || row.type || '--',
                row.contentType || 'Non-Paid',
                row.publisher || '--',
                row.website || '--',
                toExcelValue(stats.monthly_organic_visitors),
                toExcelValue(stats.authority_score),
                toExcelValue(stats.facebook),
                toExcelValue(stats.instagram),
                toExcelValue(stats.youtube),
                toExcelValue(stats.tiktok),
                toExcelValue(stats.other),
                row.contact_name || '--',
                row.contact_email || '--',
                row.requirement || row.notes || '--',
                Array.isArray(row.tags) ? row.tags.join(', ') : (row.tags || '--'),
                formatDate(row.date_added || row.createdAt),
                row.notes || '',
            ];
        });
        const numCols = header.length;
        const titleRow = ['Content Opportunities List', ...Array(numCols - 1).fill('')];
        const spacerRow = Array(numCols).fill('');
        const sheetData = [titleRow, spacerRow, header, ...data];
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        // Apply Title Style
        if (worksheet['A1']) {
            worksheet['A1'].s = titleStyle;
        }
        worksheet['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: numCols - 1 } },
        ];
        // Apply Header and Cell Styles
        for (let r = 0; r < sheetData.length; r++) {
            for (let c = 0; c < numCols; c++) {
                const cellRef = XLSX.utils.encode_cell({ r, c });
                if (!worksheet[cellRef])
                    continue;
                if (r === 2) {
                    worksheet[cellRef].s = columnHeaderStyle;
                }
                else if (r > 2) {
                    worksheet[cellRef].s = cellStyle;
                }
            }
        }
        // Set Column Widths
        const wscols = header.map(() => ({ wch: 22 }));
        worksheet['!cols'] = wscols;
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Content Opportunities');
        const fileName = `Content_Opportunities_${new Date().toISOString().split('T')[0]}.xlsx`;
        XLSX.writeFile(workbook, fileName);
    }
    catch (error) {
        console.error('Failed to export content opportunities:', error);
        toast.info('Failed to export. Please try again.');
    }
}
export default exportContentOpportunity;
